module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Brittnau-3bff88dd0b955aa6497d17ed383ed2b0.svg";